var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"courseTime_pie",attrs:{"id":"courseTime_pie"}})
}
var staticRenderFns = []

export { render, staticRenderFns }